<form [formGroup]="formGroup">
  <mat-form-field style="width: 100%">
    <mat-label>State</mat-label>
    <input
      [formControl]="stateControl"
      matInput
      autocomplete="off"
      formControlName="stateControl"
      [required]="required"
      type="text"
      id="state.name"
      [value]="location?.state"
      [lcsSingleSelect]="stateSelect"
      lcsStaticSelect
      (search)="onSearch($event)"
      (reset)="onSearchReset()"
      />
      <lcs-static-select #stateSelect [displayWith]="displayWith">
        @for (state of searchedStateMappings; track state) {
          <lcs-option [value]="state.abbreviation">
            {{ state.name }} - {{ state.abbreviation }}
          </lcs-option>
        }
      </lcs-static-select>
      @if (stateControl.hasError('required')) {
        <mat-error> State Field is Required. </mat-error>
      }
      @if (stateControl.hasError('pattern')) {
        <mat-error> State Field is Invalid. </mat-error>
      }
    </mat-form-field>
  </form>
